export const formMappings = {
  "2025 Conference Registration": {
    formId: "15",
    formName: "2025 Conference Registration",
    version: "2",
    registrantFormId: 16,
    fieldMappings: {
      firstName: "s7ztq32",
      lastName: "pu0bc32",
      email: "jgfy32",
      phone: "g8im732",
      city: "i4st6",
      state: "cm1kq",
      Registrants: "9v3kh2",
      paid: "fmz5v32",
      paidID: 529,
      "Checked In": "opjkc32",
      checkedInID: 489,
      "Number of Registrants": "yc9mo2",
      gender: "85tfd32",
      "Staying in Hotel": "s2voc3",
      "Last Time Attended": "7ckkp3",
      "Hear about Conference": "atx9k3",
      "Getting to Conference by": "ms09t3",
      "Most Active Social Media": "6icl83",
      "Food Allergies": "18a012",
      "Special Accommodations": "m2jup2",
      "Member Participation": "bpc1r32",
      "Emergency Contact Name": "uu13w3",
      "Emergency Contact Phone": "hx03y3",
      Age: "i6b3v32",
      Total: "p2l9j2-value",
      Ethnicity: "b3bic3",
      notes: "59edf",
      notesID: 530,
    },
    familyDiscount: 0.1,
    bazaarTable: {
      formId: "17",
      fieldMappings: {
        firstName: "s7ztq33",
        lastName: "pu0bc33",
        companyName: "zwygr",
        email: "jgfy33",
        phone: "g8im733",
        registeredForConference: "ydkc03",
        numberOfTables: "afp6e2",
        description: "2wbub3",
        paid: "fmz5v33",
        paidAmount: "p2l9j3-value",
      },
    },
    transportationRequest: {
      formId: "19",
      fieldMappings: {
        firstName: "s7ztq332",
        lastName: "pu0bc332",
        email: "jgfy332",
        phone: "g8im7332",
        numberOfPeople: "afp6e3",
        luggageCount: "r36ve",
        needCarSeat: "xqjp",
        arrivalDate: "jihis",
        arrivalTime: "20m5l",
        arrivalFlightNumber: "zvg15",
        departureDate: "hlr4c",
        departureTime: "dka9y",
        departureFlightNumber: "dekux",
        totalCost: "u45vj-value",
        paid: "fmz5v332",
        paidID: 532,
      },
    },
  },
  "2024 Conference Registration": {
    formId: "13",
    formName: "2024 Conference Registration",
    version: "1",
    registrantFormId: 14,
    fieldMappings: {
      firstName: "s7ztq3",
      lastName: "pu0bc3",
      email: "jgfy3",
      phone: "g8im73",
      address_object: "ns7242-value",
      address: "line1",
      city: "city",
      state: "state",
      zip: "zip",
      country: "country",
      Registrants: "9v3kh",
      paid: "fmz5v3",
      paidID: 454,
      "Checked In": "opjkc3",
      checkedInID: 426,
      "Number of Registrants": "yc9mo",
      gender: "85tfd3",
      "Staying in Hotel": "s2voc2",
      "Last Time Attended": "7ckkp2",
      "Hear about Conference": "atx9k2",
      "Most Active Social Media": "6icl82",
      "Getting to Conference by": "ms09t2",
      "Food Allergies": "18a01",
      "Special Accommodations": "m2jup",
      "Member Participation": "bpc1r3",
      "Emergency Contact Name": "uu13w2",
      "Emergency Contact Phone": "hx03y2",
      Age: "i6b3v3",
      Total: "p2l9j-value",
    },
    familyDiscount: 0.12,
  },
};
